export enum UserLoginResult {
    success = 0,
    subscriptionNotFound = 1,
    subscriptionExpired = 2,
    emailNotFound = 3,
    incorrectPassword = 4,
    emailNotVerified = 5,
    locked = 6,
    pendingEmailVerification = 7
}